import PropTypes from 'prop-types';
import Alert from "components/ui/Alert/Alert";
import { useView } from "features/view/context/ViewContext";
import Loader from "components/ui/Loader/Loader";
import MonthlyHighlightTeaser from "features/monthlyhighlights/components/MonthlyHighlightTeaser";
import ViewPager from "features/view/components/Pager/ViewPager";
import MonthlyHighlightCurrent from "features/monthlyhighlights/components/MonthlyHighlightCurrent";

const ViewMonthlyHighlights = () => {
  const { view, isLoading } = useView();

  if (isLoading) {
    return <Loader/>;
  }

  if (!view?.search_results?.length) {
    return <Alert title={ `Helaas...` } message={ `Er zijn voor deze manad nog geen uitgelichte onderwerpen, kom later nog eens terug.` }/>
  }

  return (
    <>
      <div className={ 'grid--content grid--content-full' }>
        <div className={ 'teasers-container--1col' }>
          { view.search_results.length > 0 && <MonthlyHighlightCurrent data={ view.search_results[0] }/> }
        </div>
      </div>
      <div className={ 'grid--content grid--content-full' }>
        <div className={ 'teasers-container--2col' }>
          {
            view.search_results.map(
              (row, index) => index > 0 && <MonthlyHighlightTeaser key={ index } data={ row }/>
            )
          }
        </div>
        <ViewPager/>
      </div>
    </>
  );
}

ViewMonthlyHighlights.propTypes = {
  layoutPersonal: PropTypes.bool,
}

export default ViewMonthlyHighlights;
